import { Col, Row } from "reactstrap";
import { jobInformationModal } from "../../../../../utils/Constant";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { openModal } from "../../../../../ReduxToolkit/Slice/UserProfileDetailsModalSlice";
import EmployeeInfoCard from "../../EmployeeInfoCard";
import { OfficialInformation } from "../../../../../Types/UserProfileDetails";
import { fetchEmployeesListThunk } from "../../../../hrZone/Users/redux/slice/EmployeesListSlie";
import { useEmployeeProfile } from "../../../../../hooks/useEmployeeProfile";
import { dateConversion } from "../../../../../utils/dateUtils";
import { useCallback, useMemo } from "react";

const FIELD_ORDER: Array<keyof OfficialInformation | string> = [
  "employeeCode",
  "name",
  "email",
  "mobileNumber",
  "alternateMobileNumber",
  "dob",
  "doj",
  "jobType",
  "designation",
  "department",
  "subDepartment",
  "location",
  "managerName",
  "additionalManagerNames",
  "probationDate",
  "userType",
];

const LABEL_MAP: Partial<Record<keyof OfficialInformation | string, string>> = {
  doj: "Date of Joining",
  dob: "Date of Birth",
  managerName: "Reporting Manager",
  additionalManagerNames: "Skip Level Manager",
  jobType: "Job",
  attendancePolicyType: "Location Type",
};

// Note: 'underProbhation' matches your existing key (typo kept intentionally)
const OMIT_KEYS: Array<keyof OfficialInformation | string> = [
  "departmentId",
  "centerId",
  "userId",
  "managerEmail",
  "managerId",
  "additionalManagerEmails",
  "additionalManagerIds",
  "role",
  "profile",
  "underProbhation",
  "subDepartmentId",
  "pettyCash",
  "jobTypeId",
  "userType",
  // You list these below too—if you intend to hide them, keep them here:
  "mobileNumber",
  "dob",
  "alternateMobileNumber",
  "allowedLocations",
  "attendancePolicyTypeId",
];

const formatDate = (v: any) => dateConversion(v, false, false, false);

const formatDateWithYear = (v: any) => dateConversion(v, false, true, false);

const EmployeeJobInfo = () => {
  const dispatch = useAppDispatch();
  const { employeeProfileDetails, loggedInEmployeeRole } = useEmployeeProfile();

  const employeeJobDetails = employeeProfileDetails?.jobInformation;

  const isEdit = ["admin", "hr"].includes(loggedInEmployeeRole);

  const handleOpenModal = useCallback(
    () => dispatch(openModal({ modalType: jobInformationModal })),
    [dispatch]
  );

  const openManagerUpdateFlow = useCallback(async () => {
    await dispatch(fetchEmployeesListThunk({ manager: true, status: 1 }));
    dispatch(openModal({ modalType: "updateManagerModal" }));
  }, [dispatch]);

  const openAttendancePolicyScheme = () => {
    dispatch(
      openModal({ modalType: "employeeAssignUpdateAttendancePolicyType" })
    );
  };

  const fieldActions = useMemo(
    () => ({
      managerName: openManagerUpdateFlow,
      additionalManagerNames: openManagerUpdateFlow,
      attendancePolicyType: openAttendancePolicyScheme,
    }),
    [openManagerUpdateFlow]
  );

  const formatters = useMemo(
    () => ({
      doj: formatDateWithYear,
      dob: formatDate,
      probationDate: formatDateWithYear,
    }),
    []
  );

  const omitKeys = useMemo(() => {
    if (loggedInEmployeeRole.toLowerCase() === "admin") return OMIT_KEYS;
    return [...OMIT_KEYS, "attendancePolicyType"];
  }, [loggedInEmployeeRole]);

  return (
    <Row>
      <Col md="6" className="mb-3">
        <Row>
          {employeeJobDetails && (
            <Col md="12">
              <EmployeeInfoCard<OfficialInformation>
                title="Job Information"
                entity={employeeJobDetails}
                showEditInfo={isEdit}
                bodyClassName="p-3"
                fieldOrder={FIELD_ORDER}
                labelMap={LABEL_MAP}
                omitKeys={omitKeys}
                iconOnClick={handleOpenModal}
                fieldActions={fieldActions}
                formatters={formatters}
                canEdit={isEdit}
              />
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default EmployeeJobInfo;
